export const SIDEBAR_MENU_TOGGLE: string = 'SIDEBAR_MENU_TOGGLE'
export const MENU_ORDER_PAGES: string = 'MENU_ORDER_PAGES'
